/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["related-titles-panel{display:block;width:100%;padding:45px 0;background-color:var(--be-divider-lighter)}related-titles-panel .header{font-size:2.5rem;padding-bottom:15px}"];
export { styles as styles };
